export enum SearchQueryTypeEnum {
    ScienceArticle = 0,
    Patent = 1,
    TopicModeling = 14
}